import { useSyncExternalStore } from 'react'
import { useIntl } from 'react-intl'

import { onDeviceClockChange, readDeviceClockWrong } from '@/shared/auth/sign-in-hop'

/**
 * On a site that signs in through the sign-in site: says plainly that the device's clock is wrong
 * when a renewed sign-in came back already expired on it, as every call fails until it is set
 * right. Renders nothing otherwise.
 */
export function DeviceClockBanner() {
  const intl = useIntl()
  const isWrong = useSyncExternalStore(onDeviceClockChange, readDeviceClockWrong)

  if (!isWrong) {
    return null
  }

  // <output> carries role="status" semantics without ARIA.
  return (
    <output className="block bg-critical px-3 py-2 text-center text-sm font-semibold text-accent-foreground sm:px-6">
      {intl.formatMessage({ id: 'shell.deviceClockWrong' })}
    </output>
  )
}
